import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import styles from "@/views/components/Toast/CustomToast.module.scss";

import classNames from "classnames/bind";
import { useEffect, useRef } from "react";
import { EventShared, ScopeShared } from "./constant";
import SharedStateBus from "./SharedStateBus";
import { setLanguageAction, setSaveVerifyAction, setThemeAction } from "@/stores/dataManager/Actions/appAction";
import { useTranslation } from "react-i18next";

import "../views/components/Toast/CustomToast.scss";
import { useGetSocketStatus, useGetStarted, useSaveVerify } from "@/controllers/gridManager/appManager/appManager";
import { useAccounts, useUserInfo } from "@/controllers/gridManager/accountsManager/accountManager";
import { registerAllAccountTopicsAction } from "@/stores/dataManager/Actions/socketUserAction";
import { SocketStatus } from "@/stores/dataStore/memoryStore/const/constIndex";
import Random from "@/utilities/random";
const cx = classNames.bind(styles);

const callerIdAccountId = Random.randomComponentId()
// const callerIdCustId = Random.randomComponentId()

const SyncDataMF2Host = (props: any) => {
    const { i18n } = useTranslation()
    const { saveVerify } = useSaveVerify()
    const isSyncing = useRef(false); // Đánh dấu fs2 và bond đã đồng bộ trạng thái xác thực chưa
    const { started } = useGetStarted();
    const { socketStatus } = useGetSocketStatus()
    const { accounts } = useAccounts()
    const { userInfo } = useUserInfo()
    //Khai các component expose cho bên app khác dùng

    const changeLanguage = ({ language }: { language: string }) => {
        setLanguageAction(language)
        i18n.changeLanguage(language);
    }

    const changeTheme = ({ theme }: { theme: string }) => {
        setThemeAction(theme)
    }

    useEffect(() => {
        SharedStateBus.on(
            EventShared.CHANGE_LANGUAGE,
            ScopeShared.MF,
            changeLanguage
        );

        SharedStateBus.on(
            EventShared.CHANGE_THEME,
            ScopeShared.MF,
            changeTheme
        );

        return () => {
            SharedStateBus.off(
                EventShared.CHANGE_LANGUAGE,
                ScopeShared.MF,
                changeLanguage
            );

            SharedStateBus.off(
                EventShared.CHANGE_THEME,
                ScopeShared.MF,
                changeTheme
            );
        };
    }, []);

    // // Đồng bộ từ fs2 -> mfCopyTrade khi lưu xác thực
    useEffect(() => {
        if (!isSyncing.current && props.tradeAuthenticated !== saveVerify) {
            setSaveVerifyAction(props.tradeAuthenticated)
            isSyncing.current = true;
        }
    }, [props.tradeAuthenticated]);

    // Đồng bộ từ mfCopyTrade -> fs2 khi lưu xác thực
    useEffect(() => {
        if (typeof props.handleSaveVerifyInfoFs2 === "function"
            && !isSyncing.current
            && props.tradeAuthenticated !== saveVerify) {
            props.handleSaveVerifyInfoFs2(saveVerify);
            isSyncing.current = true;
        }
    }, [saveVerify]);

    // Reset after syncing
    useEffect(() => {
        if (saveVerify === props.tradeAuthenticated) {
            isSyncing.current = false;
        }
    }, [saveVerify, props.tradeAuthenticated]);

    // //update token khi thay đổi
    // useEffect(() => {
    //     dispatch(authorizationSuccess(props.objectData.token));
    //     if (!props.objectData.token) {
    //         dispatch({
    //             type: actionTypes.FETCH_USER_INFO_BOND_SUCCESS,
    //             userInfoBond: {}
    //         });
    //     }
    // }, [props.objectData.token]);


    // useEffect(() => {
    //     if (props.objectData.fs2Logout)
    //         dispatch(fs2Logout());
    // }, [props.objectData.fs2Logout]);


    useEffect(() => {
        if (started === true && socketStatus === SocketStatus.CONNECTED) {
            registerAllAccountTopicsAction(accounts, callerIdAccountId)
            // registerCustomerTopicsAction(userInfo.custid, callerIdCustId)
        }
    }, [started, socketStatus, accounts])


    return (
        <>
            <ToastContainer
                className={`${cx("toast-container-mf")} toast-container-mf-overwrite`} toastClassName={cx("toast-item")} bodyClassName={cx("toast-item-body")}
                autoClose={5000} hideProgressBar={true} pauseOnHover={false}
                pauseOnFocusLoss={true} closeOnClick={false} draggable={false}
            />
        </>
    )
};

export default SyncDataMF2Host;
